import { render, staticRenderFns } from "./unreadTopic.vue?vue&type=template&id=c88f884c"
import script from "./unreadTopic.vue?vue&type=script&lang=js"
export * from "./unreadTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports